import { PageHeader, PageLayout, Stepper } from '../common'
import styles from './PostComposerWorkflow.module.css'

// Shared outer shell for every post composer: header (title/subtitle/
// breadcrumb/actions), an optional draft banner, an optional stepper, and a
// body. Individual and Command Center bodies diverge structurally (Command
// Center's stepper and draft banner live inside its own form, at a narrower
// width than the two-column grid below) so `children` overrides the default
// editor/preview body entirely when supplied, while still sharing the header
// seam and page chrome. Neither consumer's markup or class names change from
// what they rendered before this shell existed.
export default function PostComposerLayout({
  title,
  subtitle,
  breadcrumbs,
  actions,
  size = 'wide',
  className = '',
  draftBanner,
  steps,
  currentStep,
  onStepChange,
  stepperClassName = '',
  editor,
  preview,
  workAreaClassName = styles.workArea,
  editorClassName = styles.editor,
  previewClassName = styles.preview,
  children,
}) {
  const body = children !== undefined ? children : (
    <>
      {draftBanner}
      {steps ? (
        <Stepper
          steps={steps}
          currentStep={currentStep}
          onStepChange={onStepChange}
          label="Post creation progress"
          className={`${styles.workflowStepper} ${stepperClassName}`.trim()}
        />
      ) : null}
      <div className={workAreaClassName}>
        {editorClassName === null ? editor : <div className={editorClassName}>{editor}</div>}
        {previewClassName === null ? preview : <div className={previewClassName}>{preview}</div>}
      </div>
    </>
  )

  return (
    <PageLayout size={size} className={`${styles.page} ${className}`.trim()}>
      <PageHeader title={title} subtitle={subtitle} breadcrumbs={breadcrumbs} actions={actions} />
      {body}
    </PageLayout>
  )
}
